import { Component, Input } from '@angular/core';
import { BaseFormControlComponent } from '../base-form-control.component';

@Component({
  selector: 'boi-form-radio-button',
  templateUrl: './form-radio-button.component.html',
  styleUrls: ['./form-radio-button.component.scss']
})
export class FormRadioButtonComponent extends BaseFormControlComponent {
  @Input() public optionList: any;
  @Input() public forceNotRequired = false;

  constructor() {
    super();
  }
}
